import { Link } from "react-router-dom";
import { UsersThree, Kanban, ChartLineUp, ArrowRight, ChatsCircle } from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "../Reveal";

const BENEFITS = [
    {
        icon: UsersThree,
        title: "Qualified International Patients",
        text: "Connect with patients actively seeking healthcare solutions.",
    },
    {
        icon: Kanban,
        title: "Streamlined Case Coordination",
        text: "Organize patient information, medical documents, consultations and treatment workflows.",
    },
    {
        icon: ChartLineUp,
        title: "International Patient Intelligence",
        text: "Gain insights into markets, specialties, patient journeys and operational performance.",
    },
];

export default function ForHospitals() {
    return (
        <section id="for-hospitals" data-testid="for-hospitals-section" className="py-28 lg:py-36 bg-brand-blue noise-overlay relative overflow-hidden">
            <div className="absolute -top-40 -right-40 w-[520px] h-[520px] rounded-full bg-brand-green/10 blur-3xl" aria-hidden="true" />
            <div className="absolute -bottom-52 -left-40 w-[520px] h-[520px] rounded-full bg-brand-green-light/10 blur-3xl" aria-hidden="true" />
            <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
                <SectionHeading
                    dark
                    chapter="08"
                    eyebrow="For Hospitals"
                    title="Turn international patient demand into a connected digital journey."
                    description="GoMedVoyage is building a technology-enabled international patient ecosystem designed to help hospitals reach qualified international patients while simplifying case coordination and patient communication."
                    testid="for-hospitals-heading"
                />
                <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-6">
                    {BENEFITS.map((b, i) => (
                        <Reveal key={b.title} delay={0.1 * i}>
                            <div
                                data-testid={`hospital-benefit-${i + 1}`}
                                className="h-full rounded-3xl border border-white/10 bg-white/5 backdrop-blur p-10 hover:bg-white/10 hover:-translate-y-1 transition-[background-color,transform] duration-300"
                            >
                                <b.icon size={36} weight="duotone" className="text-brand-green-light" />
                                <h3 className="mt-6 font-heading text-xl font-semibold text-white">{b.title}</h3>
                                <p className="mt-3 text-sm leading-relaxed text-white/70">{b.text}</p>
                            </div>
                        </Reveal>
                    ))}
                </div>
                <Reveal delay={0.3}>
                    <div className="mt-14 flex flex-wrap items-center gap-4">
                        <Link
                            data-testid="become-partner-cta"
                            to="/partner"
                            className="inline-flex items-center gap-2 rounded-full bg-brand-green px-8 py-4 text-sm font-semibold text-white shadow-lg shadow-brand-green/30 hover:bg-brand-green-light active:scale-95 transition-[background-color,box-shadow,transform] duration-200"
                        >
                            Become a GoMedVoyage Partner
                            <ArrowRight size={16} weight="bold" />
                        </Link>
                        <Link
                            data-testid="talk-to-team-cta"
                            to="/contact"
                            className="inline-flex items-center gap-2 rounded-full border border-white/25 px-8 py-4 text-sm font-semibold text-white hover:bg-white/10 active:scale-95 transition-[background-color,transform] duration-200"
                        >
                            <ChatsCircle size={16} weight="bold" />
                            Talk to Our Team
                        </Link>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
